import React from 'react'
import { IconButton, makeStyles } from '@material-ui/core'
import { useSelector } from 'react-redux'
import { Modal, PageTitle } from 'web/src/app/root/components/common'
import { WeightIcon, XIcon } from 'lucide-react'
import { ButtonV2 } from 'web/src/app/root/components/common/button-v2'
import { SETTING_TYPES } from '../../location-settings'

const useStyles = makeStyles(theme => ({
    root: {
        maxHeight: '90vh',
        overflowY: 'auto',
        display: 'flex',
        flexDirection: 'column'
    },
    pageTitle: {
        marginBottom: 40
    }
}))

export const SettingsCreateSelectModal = ({
    onClose,
    availableSettingTypes,
    open,
    onSelectSettingType
}) => {
    const classes = useStyles()
    const locale = useSelector(state => state.main.locale)
    const theme = useSelector(state => state.main.theme)

    return (
        <Modal size="md" onClose={onClose} open={open} className={classes.root}>
            <div
                style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'flex-end',
                    marginTop: -20
                }}
            >
                <IconButton onClick={onClose}>
                    <XIcon size={18} color={theme.primary} />
                </IconButton>
            </div>
            <PageTitle
                title={locale.locations.selectSettingType}
                className={classes.pageTitle}
            />
            {availableSettingTypes.map(st => (
                <ButtonV2
                    key={st.type}
                    onClick={() => onSelectSettingType(st.type)}
                >
                    {st.type === SETTING_TYPES.BAIT_SETTINGS ? (
                        <div
                            style={{
                                display: 'flex',
                                alignItems: 'center',
                                gap: 8,
                                padding: 8
                            }}
                        >
                            <WeightIcon size={24} color={theme.primary} />
                            <div style={{ fontSize: 18 }}>{st.label}</div>
                        </div>
                    ) : (
                        <div>{st.label}</div>
                    )}
                </ButtonV2>
            ))}
        </Modal>
    )
}
